import { combineEpics } from 'redux-observable';
import { filter, ignoreElements, map, tap, mergeMap } from 'rxjs/operators';

import { HeaderKey } from '../../../services/authorization.service';
import { RootEpic } from '../../../store/epics';
import {
  authorizationExpiredError,
  authorizeWithOtpPhoneInUse,
  authorizeWithOtpSuccess,
  clearAuthorization,
  loadLocalStorageSession,
  loadLocalStorageSessionSuccess,
} from '../reducer/session';

const loadLocalStorageSessionEpic: RootEpic = (action$, _state$, { localStorage }) => {
  return action$.pipe(
    filter(loadLocalStorageSession.match),
    map(() =>
      loadLocalStorageSessionSuccess({
        verifying: Boolean(localStorage.getItem(HeaderKey.VerificationToken)),
        authorized: Boolean(localStorage.getItem(HeaderKey.AuthToken)),
      }),
    ),
  );
};

const authorizeWithOtpSuccessEpic: RootEpic = (action$, _state$, { localStorage }) => {
  return action$.pipe(
    filter((a) => authorizeWithOtpSuccess.match(a) || authorizeWithOtpPhoneInUse.match(a)),
    tap(() => {
      localStorage.removeItem(HeaderKey.VerificationToken);
    }),
    ignoreElements(),
  );
};

const clearAuthorizationEpic: RootEpic = (action$, _state$, { localStorage }) => {
  return action$.pipe(
    filter(clearAuthorization.match),
    tap((action) => {
      if (action.payload === 'authorized') {
        localStorage.removeItem(HeaderKey.AuthToken);
      } else if (action.payload === 'verifying') {
        localStorage.removeItem(HeaderKey.VerificationToken);
      } else {
        localStorage.removeItem(HeaderKey.AuthToken);
        localStorage.removeItem(HeaderKey.VerificationToken);
      }
    }),
    mergeMap(() => [
      authorizationExpiredError({
        message: 'Your session expired. You can enter your email and phone to resume your existing application.',
      }),
    ]),
  );
};

export const sessionLocalStorageEpic = combineEpics(
  authorizeWithOtpSuccessEpic,
  clearAuthorizationEpic,
  loadLocalStorageSessionEpic,
);
